import * as React from 'react';
import { Field } from 'redux-form';
import FormUploader from '@inqool/uas-web-core/es/components/controls/Uploader';
import { formWrapper } from '@inqool/uas-web-core/es/components/controls/reduxFormWrappers';

import * as T from '@components/form/Uploader/_uploaderTypes';

const Uploader: React.SFC<T.OutterProps> = ({
  value,
  onChange,
  onComplete,
  children,
  url = '/metropolis/api/files/'
}) => (
  <div>
    <FormUploader
      url={url}
      hideProgress={true}
      onComplete={complete => {
        onComplete ? onComplete(complete) : onChange(value ? [...value, complete.response] : [complete.response]);
      }}
    >
      {children}
    </FormUploader>
  </div>
);

export default formWrapper(Uploader);

export class UploaderField extends Field<T.OutterCustomProps> {}



// WEBPACK FOOTER //
// ./src/components/form/Uploader/Uploader.tsx